module.exports = __webpack_public_path__ + "static/media/factory.1e1572c4.jpg";